import { render } from "./errorLog.vue?vue&type=template&id=1c148b64&scoped=true"
import script from "./errorLog.vue?vue&type=script&lang=js"
export * from "./errorLog.vue?vue&type=script&lang=js"

import "./errorLog.vue?vue&type=style&index=0&id=1c148b64&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c148b64"]])

export default __exports__